/**
 * Returns a formatted string of range between two dates
 * @param {Date} fromDate The start date
 * @param {Date} toDate The end date
 * @returns {String}
 */
export default function getDateRange(fromDate, toDate) {
  //console.log(fromDate)
  if (fromDate && fromDate !== "") {
    if (toDate && toDate !== "") {
      return (
        getMonth(fromDate) +
        " " +
        fromDate.getDate() +
        " - " +
        getMonth(toDate) +
        " " +
        toDate.getDate()
      );
    } else {
      const today = new Date().setHours(0, 0, 0, 0);
      const fromDateZero = fromDate.setHours(0, 0, 0, 0);
      //console.log(fromDate.setHours(0,0,0,0), today.setHours(0,0,0,0))
      if (fromDateZero === today) {
        return "Today, " + getMonth(fromDate) + " " + fromDate.getDate();
      }
      //console.log(fromDateZero - 86400000, today)
      if (fromDateZero - 86400000 === today) {
        return "Tomorrow, " + getMonth(fromDate) + " " + fromDate.getDate();
      }
    }
  }
  return "";
}

/**
 *  Returns the month representation in short for a date
 *
 * @param {Date} inputDate
 * @returns
 */
function getMonth(inputDate) {
  return inputDate.toLocaleString("en-US", { month: "short" });
}

export const getGreeting = (hr) => {
  var split_afternoon = 12; //24hr time to split the afternoon
  var split_evening = 17; //24hr time to split the evening
  var currentHour = parseFloat(hr);

  let g;

  if (currentHour >= split_afternoon && currentHour < split_evening) {
    g = "Afternoon";
  } else if (currentHour >= split_evening) {
    g = "Evening";
  } else {
    g = "Morning";
  }

  return g;
};
